/** Official Apple App Store + Google Play download badges. */
export function StoreBadges({
  className = "",
  height = 48,
  appStoreHref = "https://www.apple.com/app-store/",
  playHref = "https://play.google.com/store/apps",
}) {
  const linkCls =
    "focus-ring inline-block transition-transform duration-200 hover:scale-[1.03] active:scale-95";

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href={appStoreHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="badge-app-store"
        aria-label="Download on the App Store"
        className={linkCls}
      >
        <img src="/badges/appstore.png" alt="Download on the App Store" style={{ height }} className="w-auto" draggable="false" />
      </a>
      <a
        href={playHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="badge-google-play"
        aria-label="Get it on Google Play"
        className={linkCls}
      >
        <img src="/badges/googleplay.png" alt="Get it on Google Play" style={{ height }} className="w-auto" draggable="false" />
      </a>
    </div>
  );
}
